import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import CartDrawer from './cart-drawer'

class CartDrawerTimerBlock extends BaseComponent {
  cartDrawer: Nullable<CartDrawer>

  constructor() {
    super()

    this.cartDrawer = this.closest('cart-drawer')
  }

  connectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.subscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }
  }

  disconnectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }
  }

  handleCartDrawerFinishUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const blockId = this.getAttribute('block-id')
    const newTimerBlock = node.querySelector(
      `cart-drawer-timer-block[block-id="${blockId}"]`,
    )

    if (!newTimerBlock) {
      return
    }

    const clonedNewTimerBlock = newTimerBlock.cloneNode(true)

    this.replaceChildren(...clonedNewTimerBlock.childNodes)
  }
}

export default CartDrawerTimerBlock
